/*
* header connection
*/

import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
let Twig = require ('twig')




export default class extends Controller {
    WhoIs;
    initialize() {
        super.initialize();
        Twig.twig({
            id: "template", //controller name
            href: "/twig/header.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "authorization", //controller name
            href: "/twig/authorization.twig",//loadable twig
            async: false
        });
        Twig.twig({
            id: "managerbase", //controller name
            href: "/twig/managerbase.twig", //подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "database", //controller name
            href: "/twig/database.twig",//loadable twig
            async: false
        });
        Twig.twig({
            id: "orderbase", //controller name
            href: "/twig/orderbase.twig", //подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "form-clientcreation", //название контроллера
            href: "/twig/form-clientcreation.twig",// подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "form-creation", //название контроллера
            href: "/twig/form-creation.twig",// подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "userdoc", //название контроллера
            href: "/twig/userdoc.twig",// подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "doctors-schedule", //название контроллера
            href: "/twig/doctors-schedule.twig",// подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "doctorsall-schedule", //название контроллера
            href: "/twig/doctorsall-schedule.twig",// подгружаемый твиг
            async: false
        });
        Twig.twig({
            id: "my-schedule", //название контроллера
            href: "/twig/my-schedule.twig",// подгружаемый твиг
            async: false
        });


    }

/*

    unload(){
        return 'Вы правда хотите обновить страницу?'
    }*/

    header(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            /*sessionStorage.removeItem('token');*/
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar);

        }

        //we turn to twig, indicate which controller to use, inside we transfer the data
        let nameVar = Twig.twig({ref: "template"}).render({
            userAuth: this.WhoIs
        });
        /* specify the block and display the contents of the twig in it*/
        $('#template__header').html(nameVar);
    }


    logout(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        location.reload();
    }

    /* doctor panel navigation */




    connect() {
        this.header();
    }
}

